import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';

@Component({
  selector: 'app-loader',
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  // Internal signals for this loader instance
  public isLoading = signal(false);
  public loadingMessage = signal<string>('');
  
  constructor() {
  }

  show(message?: string): void {
    this.isLoading.set(true);
    this.loadingMessage.set(message || '');
  }

  hide(): void {
    this.isLoading.set(false);
    this.loadingMessage.set('');
  }
}
